<template>
  <section class="app-ecommerce-details">
    <!-- Content -->
    <b-card no-body v-if="book">
      <b-card-body>
        <b-row class="my-2">
          <!-- Left: Product Image Container -->
          <b-col
            cols="12"
            md="5"
            class="
              d-flex
              align-items-center
              justify-content-center
              mb-2 mb-md-0
            "
          >
            <div class="d-flex align-items-center justify-content-center">
              <b-img
                width="500"
                :src="require('@/assets/images/banner/book.jpeg')"
                :alt="`Image of ${book.title}`"
                class="product-img"
                thumbnail
              />
            </div>
          </b-col>

          <!-- Right: Product Details -->
          <b-col cols="12" md="7">
            <!-- Product Name -->
            <h4>{{ book.title }}</h4>

            <!-- Price And Ratings -->
            <div class="ecommerce-details-price d-flex flex-wrap mt-1">
              <!-- <h4 class="item-price mr-1">${{ book.price }}</h4> -->
              <ul class="unstyled-list list-inline pl-1 border-left">
                <li
                  v-for="star in 5"
                  :key="star"
                  class="ratings-list-item mr-25"
                >
                  <feather-icon
                    icon="StarIcon"
                    size="18"
                    :class="[
                      { 'fill-current': star <= book.rating },
                      star <= book.rating ? 'text-warning' : 'text-muted',
                    ]"
                  />
                </li>
              </ul>
            </div>

            <!-- Avability -->
            <b-card-text>
              <span class="text-success">
                {{ book.category.name }}</span
              ></b-card-text
            >
            <hr />
            <!-- Product Description -->
            <b-card-text v-html="book.Description"> </b-card-text>
            <hr />

            <b-card-text>
              <span class="text-info">
                {{ book.file_setting.type }}</span
              ></b-card-text
            >
            <hr />
            <b-card-text>
              <span class="text-warning">
                {{ book.licenses.text }}</span
              ></b-card-text
            >
            <hr />
            <div class="d-flex flex-column flex-sm-row pt-1">
              <b-button
                variant="primary"
                class="btn-cart mr-0 mr-sm-1 mb-1 mb-sm-0"
                :href="config.serverUrl + '/' + book.file_url"
                download
              >
                <feather-icon icon="DownloadIcon" class="mr-50" />
                <span>{{ $t("edu_courses.download") }} </span>
              </b-button>

              <b-dropdown
                variant="outline-secondary"
                no-caret
                toggle-class="btn-icon"
                class="btn-share"
                right
              >
                <template #button-content>
                  <feather-icon icon="Share2Icon" />
                </template>
                <b-dropdown-item
                  v-for="icon in [
                    'FacebookIcon',
                    'TwitterIcon',
                    'YoutubeIcon',
                    'InstagramIcon',
                  ]"
                  :key="icon"
                >
                  <feather-icon :icon="icon" />
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import controller from "../../../Controllers/LibraryController";
import config from "@/config/config";

export default {
  data() {
    return {
      book: null,
      config: config,
    };
  },
  async created() {
    this.book = await new controller().Show(this.$route.params.id, {
      with: ["licenses", "category", "fileSetting"],
    });
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";
</style>
